<template>
  <main-layout
    class="quality"
    page-title="快检项目明细"
    @listen-back="goBack"
    customBack
  >
    <div slot="main-content" class="main-content" v-loading="loading">
      <div class="item-option" v-for="item in list" :key="item.id">
        <div class="info-result">
          结论<span
            class="status-color"
            :class="
              item.verdict_id == 2
                ? 'red-color'
                : item.verdict_id == 1
                ? 'green-color'
                : ''
            "
            >{{
              item.verdict_id == 1
                ? "阴性"
                : item.verdict_id == 2
                ? "阳性"
                : "--"
            }}</span
          >
        </div>
        <div class="content-info">
          <el-row class="info-row">
            <el-col :span="3"><div>食品检测编号</div></el-col>
            <el-col :span="3"
              ><div>{{ item.food_check_id || "--" }}</div></el-col
            >
            <el-col :span="3"><div>品种编号</div></el-col>
            <el-col :span="3"
              ><div>{{ item.special_id || "--" }}</div></el-col
            >
            <el-col :span="3"><div>抽样方式</div></el-col>
            <el-col :span="3"
              ><div>
                {{
                  item.check_class_id === 1
                    ? "企业自检"
                    : item.check_class_id === 2
                    ? "常规抽检"
                    : item.check_class_id === 3
                    ? "专项检查"
                    : item.check_class_id === 4
                    ? "监管检测"
                    : "--"
                }}
              </div></el-col
            >
            <el-col :span="3"><div>Rate抑制率</div></el-col>
            <el-col :span="3"
              ><div>{{ item.rate + "%" || "--" }}</div></el-col
            >
          </el-row>
          <el-row class="info-row">
            <el-col :span="3"><div>样品大类</div></el-col>
            <el-col :span="3"
              ><div>{{ item.great_kind || "--" }}</div></el-col
            >
            <el-col :span="3"><div>样品小类</div></el-col>
            <el-col :span="3"
              ><div>{{ item.little_kind || "--" }}</div></el-col
            >
            <el-col :span="3"><div>样品名称</div></el-col>
            <el-col :span="3"
              ><div>{{ item.sample_name || "--" }}</div></el-col
            >
            <el-col :span="3"><div>样品唯一识别码</div></el-col>
            <el-col :span="3"
              ><div>{{ item.special_idcard || "--" }}</div></el-col
            >
          </el-row>
          <el-row class="info-row">
            <el-col :span="3"><div>样品产地</div></el-col>
            <el-col :span="3"
              ><div>{{ item.habitat_name || "--" }}</div></el-col
            >
            <el-col :span="3"><div>样品生产单位</div></el-col>
            <el-col :span="3"
              ><div>{{ item.producer || "--" }}</div></el-col
            >
            <el-col :span="3"><div>样品生产日期</div></el-col>
            <el-col :span="3"
              ><div>
                {{ item.produce_date || "--" | formatDate("yyyy-MM-dd") }}
              </div></el-col
            >
            <el-col :span="3"><div>样品送检日期</div></el-col>
            <el-col :span="3"
              ><div>
                {{ item.send_date || "--" | formatDate("yyyy-MM-dd") }}
              </div></el-col
            >
          </el-row>
          <el-row class="info-row">
            <el-col :span="3"><div>样品抽样基数</div></el-col>
            <el-col :span="3"
              ><div>{{ item.send_base_num || "--" }}</div></el-col
            >
            <el-col :span="3"><div>样品来样状态</div></el-col>
            <el-col :span="3"
              ><div>{{ item.sample_state || "--" }}</div></el-col
            >
            <el-col :span="3"><div>样品抽样地点</div></el-col>
            <el-col :span="3"
              ><div>{{ item.sample_adress || "--" }}</div></el-col
            >
            <el-col :span="3"><div>样品数量</div></el-col>
            <el-col :span="3"
              ><div>{{ item.sample_amount || "--" }}</div></el-col
            >
          </el-row>
          <el-row class="info-row">
            <el-col :span="3"><div>检测项目</div></el-col>
            <el-col :span="3"
              ><div>{{ item.check_project || "--" }}</div></el-col
            >
            <el-col :span="3"><div>检测类型</div></el-col>
            <el-col :span="3"
              ><div>
                {{
                  item.check_type == 1
                    ? "速测法"
                    : item.check_type == 2
                    ? "定量法"
                    : "--"
                }}
              </div></el-col
            >
            <el-col :span="3"><div>检验依据</div></el-col>
            <el-col :span="3"
              ><div>{{ item.pursuant || "--" }}</div></el-col
            >
            <el-col :span="3"><div>使用仪器</div></el-col>
            <el-col :span="3"
              ><div>{{ item.instrument || "--" }}</div></el-col
            >
          </el-row>
          <el-row class="info-row">
            <el-col :span="3"><div>检测结论</div></el-col>
            <el-col :span="3"
              ><div>{{ item.check_verdict || "--" }}</div></el-col
            >
            <el-col :span="3"><div>对应检测地块</div></el-col>
            <el-col :span="3"
              ><div>{{ item.dkid || "--" }}</div></el-col
            >
            <el-col :span="3"><div>被检主体编号</div></el-col>
            <el-col :span="3"
              ><div>
                {{ item.jyzt_code ? "NO:" + item.jyzt_code : "--" }}
              </div></el-col
            >
            <el-col :span="3"><div>被检主体名称</div></el-col>
            <el-col :span="3"
              ><div>
                {{ item.jyzt_name || "--" }}
              </div></el-col
            >
          </el-row>
          <el-row class="info-row">
            <el-col :span="3"><div>采样编号</div></el-col>
            <el-col :span="3"
              ><div>
                {{ item.sample_no ? "NO:" + item.sample_no : "--" }}
              </div></el-col
            >
            <el-col :span="3"><div>检测人</div></el-col>
            <el-col :span="3"
              ><div>{{ item.check_user || "--" }}</div></el-col
            >
            <el-col :span="3"><div>检测时间</div></el-col>
            <el-col :span="3"
              ><div>
                {{ item.check_date || "--" | formatDate("yyyy-MM-dd") }}
              </div></el-col
            >
            <el-col :span="3"><div>上传时间</div></el-col>
            <el-col :span="3"
              ><div>
                {{ item.upload_date || "--" | formatDate("yyyy-MM-dd") }}
              </div></el-col
            >
          </el-row>
          <el-row class="info-row">
            <el-col :span="3"><div>备注:</div></el-col>
            <el-col :span="21"
              ><div class="remark">
                {{ item.remark || "--" }}
              </div></el-col
            >
          </el-row>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
// import { getStorage } from "@/utils/storage";
import { qualityInspection } from "@/api/request/snkd.produce";
import { mapState, mapActions } from "vuex";

export default {
  name: "InsuranceList",
  components: { MainLayout },
  data() {
    return {
      detailInfo: {},
      loading: false,
      list: [],
    };
  },
  computed: {
    ...mapState(["companyId", "farmId"]),
  },

  async created() {
    await this.getDetailServe();
  },
  mounted() {},
  methods: {
    ...mapActions("permission", ["hasPermission"]),

    //获取项目明细数据
    async getDetailServe() {
      this.loading = true;
      const { respCode, obj } =
        await qualityInspection.getQualityResultDetailListServe({
          id: this.$route.query.id,
        });
      if (respCode === 0) {
        this.list = obj;
        // this.detailInfo = obj[0];
        this.loading = false;
      }
    },
    // 返回上一级跳转到列表页
    goBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.quality {
  .main-content {
    width: 1200px;
    height: 100%;
    background: #fff;
    margin: 0 auto;
    padding: 30px;
    box-sizing: border-box;
    .item-option {
      background-color: #fff;
    }
    .info-result {
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 26px;
      height: 26px;

      color: #333333;
      span {
        margin-left: 20px;
      }
      .status-color {
        margin-left: 20px;
      }
      .green-color {
        color: #38af1f;
      }
      .red-color {
        color: red;
      }
    }
    .content-info {
      margin-top: 24px;
      border: 1px solid #e0e0e0;
      text-align: center;

      .info-row {
        height: 60px;
        color: #999;
        font-weight: 400;
        font-size: 14px;
        line-height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        .el-col:nth-child(2n) div {
          line-height: 16px;
          width: 100%;
          max-width: 100%;
          overflow: hidden;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          text-align: left;
          padding: 0 3px;
          box-sizing: border-box;
        }
        .el-col:nth-child(2n-1) {
          line-height: 60px;
          background-color: #f7f9fb;
          text-align: center;
          font-weight: 700;
          color: #666666;
        }
      }
      .remark {
        text-align: left;
      }
    }
  }
}
</style>
